@if (!isLoading()) {
  @if (isLoggedIn()) {
    <oui-layout logoUrl="assets/logo_proxee.svg" menuType="internal" [menu]="menu">
      <oui-header [userName]="userName()" [userMenu]="userMenu">
        <ng-container oui-header-actions>
          <oui-nav-button iconPrefix="help" [menuItem]="aideEnLigneLink">
            Aide en ligne
          </oui-nav-button>
        </ng-container>
      </oui-header>

      <oui-content-layout>
        @if (displayImportantMessage()) {
          <oui-important-message
            class="renouvellement-com-adi-{{ isEligibleCommissionAdi() }}">
            @if (isEligibleRenouvellement()) {
              <oui-important-message-item
                message="Période de renouvellement :  indiquez votre choix avant le 31 juillet minuit si vous souhaitez poursuivre votre collaboration avec les sociétés Finzzle Groupe."
                ctaText="Répondre maintenant"
                (ctaClick)="openRenouvellementDialog()"></oui-important-message-item>
            } @else if (isEligibleCommissionAdi()) {
              <oui-important-message-item
                message="Période de renouvellement Commission ADI:  indiquez votre choix de commission assurance décès invalidité."
                ctaText="Faire son choix maintenant"
                (ctaClick)="
                  openRenouvellementComAdiDialog()
                "></oui-important-message-item>
            }
            <!-- Angular ne supporte pas les @if nestés ici... -->
            @if (resiliationMessage() && resiliation()!.statutConsultant === 'a_signer') {
              <oui-important-message-item
                [message]="resiliationMessage()!"
                ctaText="Annuler la procédure"
                (ctaClick)="openCancelResiliationDialog()"></oui-important-message-item>
            } @else if (resiliationMessage()) {
              <oui-important-message-item
                [message]="resiliationMessage()!"></oui-important-message-item>
            }
          </oui-important-message>
        }

        <router-outlet></router-outlet>
      </oui-content-layout>
    </oui-layout>
  } @else {
    <lib-global-error-page errorType="consultant"></lib-global-error-page>
    <oui-layout logoUrl="assets/logo_proxee.svg"></oui-layout>
  }
} @else {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
}

<lib-fiche-consultant-panel
  [disableResiliation]="isResiliation()"
  (requestResiliation)="openResiliationDialog()"></lib-fiche-consultant-panel>
